import { render, staticRenderFns } from "./IDIcon.vue?vue&type=template&id=c91b653c&scoped=true&lang=true&"
import script from "./IDIcon.vue?vue&type=script&lang=js&"
export * from "./IDIcon.vue?vue&type=script&lang=js&"
import style0 from "./IDIcon.vue?vue&type=style&index=0&id=c91b653c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91b653c",
  null
  
)

export default component.exports